import { AddIcon, ChevronDownIcon, EditIcon, ExternalLinkIcon, HamburgerIcon, RepeatIcon, SearchIcon } from '@chakra-ui/icons';
import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Avatar, Badge, Box, Button, Card, CardBody, Checkbox, Flex, FormControl, FormLabel, Heading, IconButton, Image, Input, InputGroup, InputLeftElement, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, SimpleGrid, Skeleton, Stack, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tooltip, Tr, useColorModeValue, useDisclosure, useToast, Portal, Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverBody, InputRightElement, CloseButton } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { IoIosMenu } from 'react-icons/io';
import { PiPlusBold } from 'react-icons/pi'
import { useNavigate } from 'react-router-dom';
import { AsyncPaginate } from 'react-select-async-paginate';
import axiosClient from '../../../../axios-client';
import outOfOrder from '../assets/images/empty-cart.png'
import { LuMinus } from "react-icons/lu";
import { RiDeleteBinLine, RiFileExcel2Fill, RiFileTransferLine } from "react-icons/ri";
import { useStateContext } from '../../../../context/ContextProvider';
import { TbListDetails } from 'react-icons/tb';
import MyPagination from '../../../../components/MyPagination';
import { FaRegEye } from 'react-icons/fa6';
import BulkStatusUpdateModal from '../../../../components/BulkStatusUpdateModal';
import DeliveryUpdateModal from '../../../../components/DeliveryUpdateModal';
import { DateRange } from 'react-date-range';
import format from 'date-fns/format';
import fr from 'date-fns/locale/fr';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { GrPowerReset } from 'react-icons/gr';



function Stock() {
    const { user, setUser, setToken, currentBusiness, setCount } = useStateContext()
    const navigate = useNavigate()
    const { t } = useTranslation();
    const toast = useToast()

    const [dataOrdres, setDataOrdres] = useState([])
    const [loading, setLoading] = useState(false)
    const [paginationData, setPaginationData] = useState([])

    const [searchTerm, setSearchTerm] = useState('');
    const [userSelected, setUserSelected] = useState('');
    const [statusSelected, setStatusSelected] = useState('');

    const [dateDebutValue, setDateDebutValue] = useState("");
    const [dateFinValue, setDateFinValue] = useState("");

    const [selectionRange, setSelectionRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    });

    const handleSelectDateRange = (ranges) => {
        const { startDate, endDate } = ranges.selection;
        setSelectionRange(ranges.selection);
        setDateDebutValue(format(startDate, 'yyyy-MM-dd'));
        setDateFinValue(format(endDate, 'yyyy-MM-dd'));
    };

    const clearDateRange = () => {
        setDateDebutValue("");
        setDateFinValue("");
        setSelectionRange({
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection',
        });
    };

    const [userStock, setUserStock] = useState([])


    const [userStockSelected, setUserStockSelected] = useState()

    const [selectedProduct, setSelectedProduct] = useState(null);

    const selectTextColor = useColorModeValue('black', 'white');
    const selectBg = useColorModeValue('transparent', 'transparent');
    const selectMenuBg = useColorModeValue('white', '#2D3748');
    const selectBorderColor = useColorModeValue('#E2E8F0', 'rgba(255, 255, 255, 0.16)');
    const selectHoverBg = useColorModeValue('#EDF2F7', '#4A5568');

    const loadProductOptions = async (search, loadedOptions, { page }) => {
        try {
            const res = await axiosClient.get(`/products/get_All_Products_names/?client=${user?.id}&page_size=20&page=${page}&search_term=${search}&userRole=${user?.role}&business=${currentBusiness?.id}`, { hideLoader: true });
            const results = res.data.results || [];
            const hasMore = res.data.next !== null && res.data.next !== undefined;

            return {
                options: results.map(product => ({
                    value: product.id,
                    label: product.title
                })),
                hasMore: hasMore,
                additional: {
                    page: page + 1,
                },
            };
        } catch (error) {
            // // console.error('Error fetching products', error);
            return { options: [], hasMore: false };
        }
    };

    const fetchUsers = async () => {
        try {
            await axiosClient.get(`/clients/getClientUsers/?id=${user.id}&role=StockManagerClient&page_size=100&business=${currentBusiness?.id}`).then(res => {
                setUserStock(res.data.results)
                // console.log('Stock users ll : ', res.data);
            })
        } catch (error) {
            // console.log('ERROR : ', error);
            setLoading(false)
        }
    }



    // PAGINATION

    const [currentPage, setCurrentPage] = useState(0);

    ////////////////////////////////the size of the table//////////////////////////////
    const PAGE_SIZE = 10;
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const handlePageSizeChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
        setCurrentPage(0);
    };


    const fetchData = async (pageSize, currentPage, searchTerm, userSelected, statusSelected, dateDebutValue, dateFinValue, productSelected) => {
        try {
            setLoading(true)
            await axiosClient.get(`/commandes/getStockOrder/?clientId=${user.id}&page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}&${statusSelected ? `statusSelected=${statusSelected}` : `statusSelected=`}&userSelected=${userSelected}&dateDebut=${dateDebutValue}&dateFin=${dateFinValue}&product=${productSelected ? productSelected.value : ''}&business=${currentBusiness?.id}`).then((res) => {
                setDataOrdres(res.data.results)
                // setDataOrdres(res.data.filter(e => e.client === user.id && e.is_deleted === false && e.status_confirmation !== "Confirmé" && (e.status_stock === "" || e.status_stock === null) && (e.status_delivery === "" || e.status_delivery === null) && (e.status_facture === "" || e.status_facture === null)))
                // console.log('RESULTS DATA : ', res.data.results);
                if (res.data.length !== 0) {
                    setDataOrdres(res.data.results)
                    setPaginationData(res.data)
                } else {
                    setDataOrdres([])
                    setPaginationData([])
                }

                if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
                    setUser({});
                    setToken(null);
                    localStorage.removeItem("tokenExpirationTime");
                    localStorage.removeItem("refreshTimeAdmin");
                    localStorage.removeItem("role");

                    // Vérifier si le toast n'est pas déjà affiché
                    if (!toast.isActive('accountDisabled')) {
                        toast({
                            id: 'accountDisabled',
                            description: t("le compte est désactivé"),
                            status: 'warning',
                            variant: 'left-accent',
                            duration: 2000,
                            isClosable: true,
                            position: 'bottom-right'
                        });
                    }
                }
            })
            setLoading(false)
        } catch (error) {
            // console.log('ERROR : ', error);
            setLoading(false)
        }
    }

    useEffect(() => {
        if (user?.id) {
            fetchUsers()
            fetchData(pageSize, currentPage, searchTerm, userSelected, statusSelected, dateDebutValue, dateFinValue, selectedProduct)
        }
    }, [user?.id, currentPage, searchTerm, pageSize, userSelected, statusSelected, dateDebutValue, dateFinValue, selectedProduct])

    // État pour stocker les lignes sélectionnées
    const [selectedRows, setSelectedRows] = useState([]);

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedRows(dataOrdres.map(order => order.id));
        } else {
            setSelectedRows([]);
        }
    };

    // Fonction pour gérer le clic sur la case à cocher
    const handleCheckboxClick = (index) => {
        // Vérifie si la ligne est déjà sélectionnée
        const selectedIndex = selectedRows.indexOf(index);
        if (selectedIndex === -1) {
            // Si la ligne n'est pas déjà sélectionnée, l'ajouter à l'état
            setSelectedRows([...selectedRows, index]);
        } else {
            // Si la ligne est déjà sélectionnée, la retirer de l'état
            setSelectedRows(selectedRows.filter((rowIndex) => rowIndex !== index));
        }
    };

    //ASSIGN ORDER

    const { isOpen, onOpen, onClose, onToggle } = useDisclosure()

    const assign_order_to = async (agentId) => {
        try {
            await axiosClient.post(`/commandes/bulk_actions/`, {
                action: 'assign',
                user_id: user.id,
                agent_id: agentId,
                order_ids: selectedRows,
                assign_type: 'assigned_to_stock'
            }).then(res => {
                fetchData(pageSize, currentPage, searchTerm, userSelected, statusSelected, dateDebutValue, dateFinValue, selectedProduct);
                toast({
                    description: t("Ordres attribués avec succès"),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                });
            });
        } catch (error) {
            // console.log('Error : ', error);
        }

        setSelectedRows([])
        onClose()
    }

    // DELETE

    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [isExportAlertOpen, setIsExportAlertOpen] = useState(false);
    const cancelRef = React.useRef()
    const [deletedId, setDeletedId] = useState()

    const onOpenAlert = (id) => {
        setIsAlertOpen(true);
        setDeletedId(id)
    };
    const onCloseAlert = () => {
        setIsAlertOpen(false);
        setDeletedId()
    };
    const onOpenExportAlert = () => setIsExportAlertOpen(true);
    const onCloseExportAlert = () => setIsExportAlertOpen(false);

    const DeleteArrayOfOrders = async () => {
        // console.log('DELETED ID ; ', deletedId);
        if (deletedId !== null) {
            try {
                await axiosClient.patch(`commandes/${deletedId}/`, {
                    is_deleted: true
                }).then(res => {
                    setDataOrdres(dataOrdres.filter(e => e.id !== deletedId))
                })
            } catch (error) {
                // console.log('ERROR : ', error);
            }
        }
        else {
            try {
                await axiosClient.post(`/commandes/bulk_actions/`, {
                    action: 'delete',
                    user_id: user.id,
                    order_ids: selectedRows
                }).then(res => {
                    fetchData(pageSize, currentPage, searchTerm, userSelected, statusSelected, dateDebutValue, dateFinValue, selectedProduct);
                    toast({
                        description: t("Ordres supprimés avec succès"),
                        status: 'success',
                        duration: 2000,
                        isClosable: true,
                        position: 'bottom-right'
                    });
                });
            } catch (error) {
                // console.log('Error : ', error);
            }
            setSelectedRows([])
        }
        onCloseAlert()
    }

    // Update status

    const [statusStock, setStatusStock] = useState('')
    const [isModalEditStatusOpen, setIsModalEditStatusOpen] = useState(false);
    const ModalEditStatusRef = React.useRef()
    const [statusId, setStatusId] = useState()

    const onOpenModalEditStatus = (id) => {
        setIsModalEditStatusOpen(true);
        setStatusId(id)
    };
    const onCloseModalEditStatus = () => {
        setIsModalEditStatusOpen(false);
        setStatusStock('')
        setStatusId()
    };

    const HandleChangeStatus = async () => {
        try {
            await axiosClient.patch(`commandes/${statusId}/`, {
                status_stock: statusStock
            }).then((res) => {
                setDataOrdres(dataOrdres.map((item) => {
                    if (item.id === res.data.id) {
                        return {
                            ...item,
                            status_stock: res.data.status_stock
                        }
                    }
                    return item
                }))
                onCloseModalEditStatus()
                toast({
                    description: t(`Statut est changé avec succès`),
                    status: 'success',
                    duration: 2000,
                    isClosable: true,
                    variant: 'left-accent',
                    position: 'bottom-right'
                })
            })
        } catch (error) {
            // console.log('ERROR : ', error);
        }
    }

    //USECOLOREMODE Variables
    const bgHoverStack = useColorModeValue('gray.200', 'gray.500')
    const borderColor = useColorModeValue("gray.300", "gray.600")
    const textSM = useColorModeValue('gray.400', 'gray.500')
    const bgPurple = useColorModeValue('purple.50', 'gray.600')

    const resetFilters = () => {
        setSearchTerm('');
        setUserSelected('');
        setStatusSelected('');
        clearDateRange();
        setSelectedProduct(null);
        setCurrentPage(0);
    };

    const handleExportExcel = async () => {
        try {
            const response = await axiosClient.get(`/export-orders/${user?.id}/?stage=stock&search_term=${searchTerm}&userSelected=${userSelected}&statusSelected=${statusSelected}&dateDebut=${dateDebutValue}&dateFin=${dateFinValue}&product=${selectedProduct ? selectedProduct.value : ''}&business=${currentBusiness?.id}`, {
                responseType: 'blob',
            });

            if (response.data.error === 'Client is disabled.' && response.data.etat === false) {
                setUser({});
                setToken(null);
                localStorage.removeItem("tokenExpirationTime");
                localStorage.removeItem("refreshTimeAdmin");
                localStorage.removeItem("role");

                // Vérifier si le toast n'est pas déjà affiché
                if (!toast.isActive('accountDisabled')) {
                    toast({
                        id: 'accountDisabled',
                        description: t("le compte est désactivé"),
                        status: 'warning',
                        variant: 'left-accent',
                        duration: 2000,
                        isClosable: true,
                        position: 'bottom-right'
                    });
                }
                return
            }

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'stock_commandes.xlsx');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);

            toast({
                description: t("Le fichier a été exporté avec succès."),
                variant: 'left-accent',
                status: 'success',
                duration: 3000,
                isClosable: true,
                position: 'bottom-right'
            });
        } catch (error) {
            toast({
                description: t("Une erreur s'est produite lors de l'exportation du fichier."),
                variant: 'left-accent',
                status: 'error',
                duration: 3000,
                isClosable: true,
                position: 'bottom-right'
            });
        }
    }


    //vider l'input de date fin
    useEffect(() => {
        if (!dateDebutValue) {
            // Si dateDebutValue est vide, on réinitialise dateFinValue
            setDateFinValue('');
        } else if (dateFinValue && dateDebutValue >= dateFinValue) {
            // Si dateDebutValue est supérieur ou égal à dateFinValue, on réinitialise dateFinValue
            setDateFinValue('');
        }
    }, [dateDebutValue, dateFinValue]);

    // Aperçu Commande
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    const [productsOrderData, setProductsOrderData] = useState([])
    const previewRef = React.useRef()
    const [previewId, setPreviewId] = useState()
    const [loadingPreview, setLoadingPreview] = useState(true)

    const onOpenPreview = async (id) => {
        setIsPreviewOpen(true);
        setLoadingPreview(true)
        await axiosClient.get(`/produitCommande/getProductsOrder/?commande=${id}&client_id=${user?.id}&userRole=${user?.role}`)
            .then((res) => {
                setProductsOrderData(res.data)

                if (res.data.error === 'Client is disabled.' && res.data.etat === false) {
                    setUser({});
                    setToken(null);
                    localStorage.removeItem("tokenExpirationTime");
                    localStorage.removeItem("refreshTimeAdmin");
                    localStorage.removeItem("role");

                    // Vérifier si le toast n'est pas déjà affiché
                    if (!toast.isActive('accountDisabled')) {
                        toast({
                            id: 'accountDisabled',
                            description: t("le compte est désactivé"),
                            status: 'warning',
                            variant: 'left-accent',
                            duration: 2000,
                            isClosable: true,
                            position: 'bottom-right'
                        });
                    }
                }
            })
            .catch((error) => {
                // console.log('ERROR : ', error)
                setLoadingPreview(false)
            })
            .finally(() => {
                setLoadingPreview(false)
            })
        setPreviewId(id)
    };
    const onClosePreview = () => {
        setIsPreviewOpen(false);
        setProductsOrderData([])
        setLoadingPreview(true)
        setPreviewId()
    };


    return (
        <Box>

            <Stack
                px={2}
                py={5}
                // mx={5}
                bg={useColorModeValue('white', 'gray.700')}
                rounded={"2xl"}
                mt={2}
            >
                <Flex align="center" gap={3} w="full" direction={{ base: 'column', lg: 'row' }} justify="space-between" mb={6}>
                    <Flex gap={3} w="full" direction={{ base: 'column', md: 'row' }} flexWrap="wrap">
                        <Select
                            borderColor={borderColor}
                            borderRadius="xl"
                            size="md"
                            fontSize={{ base: 13, lg: 16 }}
                            w={{ base: '100%', md: '200px' }}
                            value={userSelected}
                            onChange={(e) => {
                                setCurrentPage(0)
                                setUserSelected(e.target.value)
                            }}
                        >
                            <option value="">{t("Tout les utilisateurs")}</option>
                            {userStock?.map((val, key) => (
                                <option key={key} value={val.id}>{`${val.first_name} ${val.last_name}`}</option>
                            ))}
                        </Select>

                        <Flex w={{ base: '100%', md: '300px' }} gap={statusSelected === 'En cours' ? 3 : 0}>
                            <Select
                                borderColor={borderColor}
                                borderRadius="xl"
                                size="md"
                                fontSize={{ base: 13, lg: 16 }}
                                w={'100%'}
                                value={statusSelected}
                                onChange={(e) => {
                                    setCurrentPage(0)
                                    setStatusSelected(e.target.value)
                                }}
                            >
                                <option value=''>{t('Statut de stock')}</option>
                                <option value='Nouveau'>{t('Nouveau')}</option>
                                <option value='Épuisé'>{t('Épuisé')}</option>
                                <option value='Annulé'>{t('Annulé')}</option>
                                <option value='En cours'>{t('En cours')}</option>
                                <option value='Emballé'>{t('Emballé')}</option>
                                <option value='Collecté'>{t('Collecté')}</option>
                            </Select>
                        </Flex>

                        <Box w={{ base: '100%', md: '200px' }}>
                            <AsyncPaginate
                                loadOptions={loadProductOptions}
                                onChange={(option) => {
                                    setCurrentPage(0);
                                    setSelectedProduct(option);
                                }}
                                value={selectedProduct}
                                isClearable
                                placeholder={t('Filtrer par produit...')}
                                noOptionsMessage={() => t("Aucun produit trouvé")}
                                additional={{ page: 1 }}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        backgroundColor: selectBg,
                                        borderColor: selectBorderColor,
                                        color: selectTextColor,
                                        minHeight: '40px',
                                        borderRadius: '12px'
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999,
                                        backgroundColor: selectMenuBg,
                                        borderRadius: '12px'
                                    }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? selectHoverBg : 'transparent',
                                        color: selectTextColor
                                    }),
                                    singleValue: (provided) => ({
                                        ...provided,
                                        color: selectTextColor
                                    }),
                                    input: (provided) => ({
                                        ...provided,
                                        color: selectTextColor
                                    })
                                }}
                            />
                        </Box>

                        <Box w={{ base: '100%', md: '250px' }}>
                            <Popover placement="bottom-start">
                                <PopoverTrigger>
                                    <InputGroup size="md">
                                        <Input
                                            readOnly
                                            value={dateDebutValue ? `${dateDebutValue} ${t("au")} ${dateFinValue}` : t("Choisir une période")}
                                            cursor="pointer"
                                            rounded="xl"
                                            borderColor={borderColor}
                                            bg={useColorModeValue('white', 'gray.700')}
                                            _hover={{ borderColor: 'purple.400' }}
                                            _focus={{ borderColor: 'purple.500', boxShadow: 'none' }}
                                        />
                                        {dateDebutValue && (
                                            <InputRightElement w="auto" pr={2}>
                                                <IconButton
                                                    variant="ghost"
                                                    size="sm"
                                                    icon={<CloseButton size="sm" />}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        clearDateRange();
                                                    }}
                                                    aria-label={t("Effacer la date")}
                                                />
                                            </InputRightElement>
                                        )}
                                    </InputGroup>
                                </PopoverTrigger>
                                <PopoverContent w="auto" p={0} border="none" shadow="2xl" zIndex={9999}>
                                    <PopoverArrow />
                                    <PopoverBody p={0}>
                                        <DateRange
                                            ranges={[selectionRange]}
                                            onChange={handleSelectDateRange}
                                            locale={fr}
                                            maxDate={new Date()}
                                            rangeColors={['#805AD5']}
                                        />
                                    </PopoverBody>
                                </PopoverContent>
                            </Popover>
                        </Box>

                        <InputGroup size="md" w={{ base: '100%', md: '200px' }}>
                            <InputLeftElement pointerEvents='none'>
                                <SearchIcon color="gray.400" />
                            </InputLeftElement>
                            <Input
                                borderColor={borderColor}
                                borderRadius="xl"
                                placeholder={t("Recherche...")}
                                value={searchTerm}
                                onChange={(e) => {
                                    setCurrentPage(0)
                                    setSearchTerm(e.target.value)
                                }}
                                _focus={{ borderColor: 'purple.500', boxShadow: 'none' }}
                            />
                        </InputGroup>

                        <IconButton
                            icon={<RiFileExcel2Fill />}
                            onClick={onOpenExportAlert}
                            colorScheme="green"
                            variant="outline"
                            rounded="xl"
                            aria-label={t("Exporter Excel")}
                            title={t("Exporter en Excel")}
                        />
                        <IconButton
                            icon={<GrPowerReset />}
                            onClick={resetFilters}
                            variant="outline"
                            colorScheme="purple"
                            rounded="xl"
                            aria-label={t("Réinitialiser")}
                            title={t("Réinitialiser les filtres")}
                        />
                    </Flex>
                </Flex>

                <Flex mb={4} justify="flex-start">
                    <DeliveryUpdateModal onSuccess={() => fetchData(pageSize, currentPage, searchTerm, userSelected, statusSelected, dateDebutValue, dateFinValue, selectedProduct)} />
                </Flex>

                <TableContainer>
                    {selectedRows.length > 0 && (
                        <Flex
                            mb={4}
                            gap={{ base: 2, md: 3 }}
                            w="100%"
                            align={{ base: 'flex-start', md: 'center' }}
                            bg={bgPurple}
                            p={3}
                            rounded="md"
                            direction={{ base: 'column', sm: 'row' }}
                            flexWrap="wrap"
                        >
                            <Text fontWeight="bold" whiteSpace="nowrap">
                                {selectedRows.length} {t("sélectionné(s)")}
                            </Text>

                            <Flex gap={2} flexWrap="wrap" align="center">
                                {["AdminClient", "ManagerClient"].includes(user.role) ? (
                                    <Button size="sm" colorScheme="purple" onClick={onOpen}>
                                        {t("Attribuer au responsable")}
                                    </Button>
                                ) : (
                                    <Button size="sm" colorScheme="purple" onClick={() => assign_order_to(user.id)}>
                                        {t("M'attribuer la sélection")}
                                    </Button>
                                )}

                                {/* ── Bulk Status Update ── */}
                                <BulkStatusUpdateModal
                                    statusField="status_stock"
                                    statusKey="status_stock"
                                    statusOptions={[
                                        { value: 'Nouveau', label: 'Nouveau' },
                                        { value: 'Épuisé', label: 'Épuisé' },
                                        { value: 'Annulé', label: 'Annulé' },
                                        { value: 'En cours', label: 'En cours' },
                                        { value: 'Emballé', label: 'Emballé' },
                                        { value: 'Collecté', label: 'Collecté' },
                                    ]}
                                    selectedRows={selectedRows}
                                    dataList={dataOrdres}
                                    isDisabled={!statusSelected}
                                    buttonLabel={statusSelected ? `→ ${statusSelected}` : t('Changer statut')}
                                    onSuccess={() => {
                                        fetchData(pageSize, currentPage, searchTerm, userSelected, statusSelected, dateDebutValue, dateFinValue, selectedProduct);
                                        setSelectedRows([]);
                                    }}
                                />

                                {["AdminClient", "ManagerClient"].includes(user.role) && (
                                    <>
                                        <Button size="sm" colorScheme="blue" onClick={() => {
                                            axiosClient.post(`/commandes/bulk_actions/`, {
                                                action: 'send_to_shipping',
                                                user_id: user.id,
                                                order_ids: selectedRows
                                            }).then(res => {
                                                fetchData(pageSize, currentPage, searchTerm, userSelected, statusSelected, dateDebutValue, dateFinValue, selectedProduct);
                                                // Refresh notification count so the bell updates immediately
                                                setCount(prev => (parseInt(prev) || 0) + 1)
                                                toast({
                                                    description: res.data.message,
                                                    status: 'success',
                                                    duration: 3000,
                                                    isClosable: true,
                                                    position: 'bottom-right'
                                                });
                                                setSelectedRows([]);
                                            }).catch(err => {
                                                toast({
                                                    description: t("Erreur lors de l'envoi au transporteur"),
                                                    status: 'error',
                                                    duration: 3000,
                                                    isClosable: true,
                                                    position: 'bottom-right'
                                                });
                                            });
                                        }}>
                                            <RiFileTransferLine style={{ marginRight: '5px' }} />
                                            {t("Envoyer au transporteur")}
                                        </Button>
                                        <Button size="sm" colorScheme="red" onClick={() => onOpenAlert(null)}>
                                            {t("Supprimer la sélection")}
                                        </Button>
                                    </>
                                )}
                            </Flex>
                        </Flex>
                    )}
                    <Table size={{ base: 'sm', md: 'md' }} variant='simple'>
                        <Thead>
                            <Tr>
                                <Th borderBottomColor='gray.400'>
                                    <Checkbox
                                        size="md"
                                        colorScheme='purple'
                                        onChange={handleSelectAll}
                                        isChecked={selectedRows.length === dataOrdres.length && dataOrdres.length > 0}
                                    />
                                </Th>
                                <Th borderBottomColor='gray.400'>{t("#ID")}</Th>
                                <Th borderBottomColor='gray.400'>{t("Responsable")}</Th>
                                <Th borderBottomColor='gray.400'>{t("Client")}</Th>
                                <Th borderBottomColor='gray.400'>{t("Adresse")}</Th>
                                <Th borderBottomColor='gray.400'>{t("Téléphone")}</Th>
                                <Th borderBottomColor='gray.400'>{t("Source")}</Th>
                                <Th borderBottomColor='gray.400'>{t("Status")}</Th>
                                <Th borderBottomColor='gray.400'>{t("Coupons")}</Th>
                                <Th borderBottomColor='gray.400'>{t("Prix")}</Th>
                                <Th borderBottomColor='gray.400'>{t("Date Création")}</Th>
                                <Th borderBottomColor='gray.400'>{t("Date Modification")}</Th>
                                <Th borderBottomColor='gray.400'>{t("Options")}</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            <>
                                {loading &&
                                    <Tr>
                                        <Td><Skeleton h={10} w={10} /></Td>
                                        <Td><Skeleton height='20px' /></Td>
                                        <Td>
                                            <Flex flexDirection={"column"} gap={2}>
                                                <Skeleton height='20px' />
                                                <Skeleton height='10px' />
                                            </Flex>
                                        </Td>
                                        <Td>
                                            <Flex flexDirection={"column"} gap={2}>
                                                <Skeleton height='20px' />
                                                <Skeleton height='10px' />
                                                <Skeleton height='10px' />
                                            </Flex>
                                        </Td>
                                        <Td><Skeleton height='20px' /></Td>
                                        <Td><Skeleton height='20px' /></Td>
                                        <Td><Skeleton height='20px' /></Td>
                                        <Td><Skeleton height='20px' /></Td>
                                        <Td><Skeleton height='20px' /></Td>
                                        <Td><Skeleton height='20px' /></Td>
                                    </Tr>
                                }
                                {
                                    dataOrdres.length > 0 ?
                                        dataOrdres.map((val, key) => {
                                            const isSelected = selectedRows.includes(val.id);
                                            return (
                                                <Tr key={key} >
                                                    <Td>
                                                        <Checkbox size="md" colorScheme='purple' _focus={"none"} _active={'none'}
                                                            onChange={() => handleCheckboxClick(val.id)}
                                                            isChecked={selectedRows.includes(val.id)} />
                                                    </Td>
                                                    <Td>
                                                        <Text>{val.code}</Text>
                                                    </Td>
                                                    <Td>
                                                        {val.assigned_to_stock ?
                                                            <Flex flexDirection="column">
                                                                <Text>{val.first_name_Stock}</Text>
                                                                <Text>{val.last_name_Stock}</Text>
                                                            </Flex>
                                                            :
                                                            <Text>-</Text>
                                                        }
                                                    </Td>
                                                    <Td>
                                                        <Flex flexDirection={"column"}>
                                                            <Text fontWeight='semibold'>{val.full_name}</Text>
                                                            {val.email !== "undefined" && <Text fontSize='sm' color={textSM}>{val.email}</Text>}
                                                        </Flex>
                                                    </Td>
                                                    <Td>
                                                        <Flex flexDirection={"column"}>
                                                            <Text fontSize={'md'}>{val.pays}, {val.ville}</Text>
                                                            <Text fontSize={'sm'} color={textSM}>{val.address}</Text>
                                                        </Flex>
                                                    </Td>
                                                    <Td>
                                                        <a href={`https://wa.me/${val.tel}`} target='blank'>
                                                            {val.tel}
                                                        </a>
                                                    </Td>
                                                    <Td>
                                                        <Text>{val.sourceAPI}</Text>
                                                    </Td>
                                                    <Td>
                                                        <Badge colorScheme={
                                                            val?.status_stock !== 'Collecté'
                                                                ? (['Épuisé', 'Annulé'].includes(val?.status_stock))
                                                                    ? 'red'
                                                                    : ([null, ''].includes(val?.status_stock))
                                                                        ? 'blue'
                                                                        : 'orange'
                                                                : 'green'
                                                        } rounded="xl" px={2} cursor='pointer' textTransform='uppercase' onClick={() => {

                                                            if (val?.status_delivery === null || val?.status_delivery === '') {
                                                                onOpenModalEditStatus(val.id)
                                                            } else {
                                                                toast({
                                                                    description:
                                                                        <Flex flexDirection='column'>
                                                                            <Text fontWeight='semibold'>{t('Désolé!')}</Text>
                                                                            <Text>{t('Impossible de modifier le statut de cette commande car elle est déjà en Livraison.')}</Text>
                                                                        </Flex>
                                                                    ,
                                                                    status: 'error',
                                                                    duration: 5000,
                                                                    isClosable: true,
                                                                    variant: 'left-accent',
                                                                    position: 'top-center'
                                                                })
                                                            }
                                                        }}>
                                                            {val?.status_stock ? t(`${val?.status_stock}`) : t('Nouveau')}
                                                        </Badge>
                                                    </Td>
                                                    <Td>
                                                        <Text textAlign='center'>
                                                            {val.coupon ? val.couponTitle : '-'}
                                                        </Text>
                                                    </Td>
                                                    <Td>
                                                        <Flex gap={1} alignItems="center">
                                                            <Text color={val?.coupon && 'gray.400'} fontSize={val?.coupon && 15} fontWeight='semibold' textDecoration={val?.coupon && 'line-through'}>{val?.price}</Text>
                                                            <Text h={"100%"} fontSize={12} >{currentBusiness?.order_currency}</Text>
                                                        </Flex>
                                                        {
                                                            val?.coupon &&
                                                            <Flex gap={1} alignItems="center">
                                                                <Text fontWeight='semibold'>{val?.priceWithCoupon}</Text>
                                                                <Text h={"100%"} fontSize={12} >{currentBusiness?.order_currency}</Text>
                                                            </Flex>
                                                        }
                                                    </Td>
                                                    <Td>
                                                        <Flex flexDirection="column">
                                                            <Text fontSize="sm" fontWeight="medium">{new Date(val.date_creation).toLocaleDateString()}</Text>
                                                            <Text fontSize="xs" color="gray.500">{new Date(val.date_creation).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</Text>
                                                        </Flex>
                                                    </Td>
                                                    <Td>
                                                        {val.date_modification ? (
                                                            <Flex flexDirection="column">
                                                                <Text fontSize="sm" fontWeight="medium">{new Date(val.date_modification).toLocaleDateString()}</Text>
                                                                <Text fontSize="xs" color="gray.500">{new Date(val.date_modification).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</Text>
                                                            </Flex>
                                                        ) : (
                                                            <Text fontSize="sm" color="gray.400">-</Text>
                                                        )}
                                                    </Td>
                                                    <Td>
                                                        <Menu>
                                                            <MenuButton
                                                                as={IconButton}
                                                                aria-label='Options'
                                                                icon={<HamburgerIcon />}
                                                                variant='outline'
                                                            />
                                                            <MenuList>
                                                                <MenuItem icon={<FaRegEye size={18} />} onClick={() => {
                                                                    onOpenPreview(val.id)
                                                                }}>
                                                                    {t("Aperçu")}
                                                                </MenuItem>
                                                                <MenuItem icon={<TbListDetails size={18} />} onClick={() => {
                                                                    navigate('/Detail-Gestion-confirmation', {
                                                                        state: {
                                                                            id: val.id,
                                                                            tel: val.tel
                                                                        }
                                                                    })
                                                                }}>
                                                                    {t("Détails")}
                                                                </MenuItem>
                                                                <MenuItem icon={<RiFileTransferLine size={18} />} onClick={() => {
                                                                    handleCheckboxClick(val.id)
                                                                    onOpen()
                                                                }}>
                                                                    {t("Attribuer")}
                                                                </MenuItem>
                                                                <MenuItem icon={<RiDeleteBinLine size={18} />} onClick={() => {
                                                                    onOpenAlert(val.id)
                                                                }}>
                                                                    {t("Supprimer")}
                                                                </MenuItem>
                                                            </MenuList>
                                                        </Menu>
                                                    </Td>
                                                </Tr>
                                            )
                                        })
                                        :
                                        <Tr>
                                            <Td colSpan={9}>
                                                <Text fontSize={16}>{t("Donnée introuvable")}</Text>
                                            </Td>
                                        </Tr>
                                }
                            </>
                        </Tbody>
                    </Table>
                </TableContainer>


                {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}
                {paginationData.length !== 0 && <Flex flexDirection={{ base: 'column', lg: "row" }} justify="space-between" align="center" w="100%">
                    <Box flex="1">
                        <MyPagination
                            paginationData={paginationData}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            PAGE_SIZE={pageSize}
                        />
                    </Box>

                    <Select rounded={"md"} size={"sm"} w="70px" value={pageSize} onChange={handlePageSizeChange}>
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </Select>
                </Flex>}
                {/* //////////////////////////////////////////Pagination////////////////////////////////////////// */}

            </Stack>



            {/* Modal to assign order */}
            <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={() => {
                onClose()
                setSelectedRows([])
            }}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{t("Attribuer la commande")}</ModalHeader>
                    <ModalCloseButton />

                    <ModalBody pb={6}>
                        <Text>
                            {t("Ici, vous pouvez attribuer une commande spécifique à un responsable de stock.")}
                        </Text>

                        <Select
                            mt={3}
                            rounded='lg'
                            size={"sm"}
                            value={userStockSelected}
                            onChange={e => setUserStockSelected(e.target.value)}
                        >
                            <option value=''>{t("Responsable de stock")}</option>
                            {userStock?.map((val, key) => {
                                return (
                                    <option key={key} value={val.id}>{`${val.first_name} ${val.last_name}`}</option>
                                )
                            })}
                        </Select>

                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme='yellow' size="sm" variant='outline' isDisabled={!userStockSelected} mr={3} onClick={() => assign_order_to(userStockSelected)}>
                            {t("Attribuer")}
                        </Button>
                        <Button onClick={() => {
                            onClose()
                            setSelectedRows([])
                        }} size="sm" >{t("Annuler")}</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>


            {/* Alert to Delete Order */}

            <AlertDialog
                isOpen={isAlertOpen}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t("Supprimer")}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            {t("êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.")}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseAlert}>
                                {t("Annuler")}
                            </Button>
                            <Button onClick={DeleteArrayOfOrders} colorScheme='red' ml={3}>
                                {t("Supprimer")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>



            {/* Alert to Update confirmation status */}

            <AlertDialog
                isOpen={isModalEditStatusOpen}
                leastDestructiveRef={ModalEditStatusRef}
                onClose={onCloseModalEditStatus}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t('Statut de stock')}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            <Text>
                                {t("Ici, vous pouvez modifier le statut de stock.")}
                            </Text>

                            <Select
                                mt={3}
                                rounded='lg'
                                size={"sm"}
                                value={statusStock}
                                onChange={e => setStatusStock(e.target.value)}
                            >
                                <option value=''>{t('Statut de stock')}</option>
                                <option value='Épuisé'>{t('Épuisé')}</option>
                                <option value='Annulé'>{t('Annulé')}</option>
                                <option value='En cours'>{t('En cours')}</option>
                                <option value='Emballé'>{t('Emballé')}</option>
                                <option value='Collecté'>{t('Collecté')}</option>
                            </Select>
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button colorScheme='yellow' size="sm" variant='outline' isDisabled={!statusStock} mr={3} onClick={HandleChangeStatus}>
                                {t("Modifier")}
                            </Button>
                            <Button onClick={onCloseModalEditStatus} size="sm" >{t("Annuler")}</Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>

            <AlertDialog isOpen={isExportAlertOpen} leastDestructiveRef={cancelRef} onClose={onCloseExportAlert}>
                <AlertDialogOverlay backdropFilter="blur(3px)">
                    <AlertDialogContent rounded="2xl">
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            {t("Confirmer l'exportation")}
                        </AlertDialogHeader>
                        <AlertDialogBody>
                            {t("Attention : l'exportation Excel dépendra des filtres actuellement appliqués sur la page. Voulez-vous continuer ?")}
                        </AlertDialogBody>
                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseExportAlert}>{t("Annuler")}</Button>
                            <Button colorScheme="green" onClick={() => { onCloseExportAlert(); handleExportExcel(); }} ml={3}>{t("Exporter")}</Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>


            {/* Preview Order */}
            < Modal closeOnOverlayClick={false} size={"2xl"} isOpen={isPreviewOpen} leastDestructiveRef={cancelRef} onClose={onClosePreview}>
                <ModalOverlay />
                <ModalContent maxHeight={'90%'}>
                    <ModalHeader>{t("Aperçu la commande")}</ModalHeader>
                    <ModalCloseButton />



                    <SimpleGrid px={{ base: 2, md: 10 }} overflowY={'auto'} mb={5} mt={2} templateColumns={{ base: 'repeat(auto-fill,minmax(250px,1fr))', md: 'repeat(auto-fill,minmax(200px,1fr))' }} spacing={7}>
                        {loadingPreview
                            ? <Skeleton marginTop={5} height='300px' borderRadius={10} />
                            : productsOrderData.map((val, key) => {
                                return (
                                    <Card key={key} mt={5} mb={5} rounded={"xl"} shadow="lg" borderWidth={1} borderColor={'gray.200'}>
                                        <CardBody p={0} m={0}>
                                            <Stack position={"relative"}>
                                                <Image
                                                    height={"200px"}
                                                    src={val.produit?.images[0]?.image}
                                                    alt='Image'
                                                    objectFit="cover"
                                                    roundedTop={"xl"}
                                                />
                                            </Stack>
                                            <Stack p={3} alignItems='start' mt={2}>
                                                <Heading fontSize={'xl'} fontFamily={'body'} fontWeight={500}>
                                                    {val.produit?.title}
                                                </Heading>
                                                {/* <Text lineHeight={5} textAlign={'justify'} color={'descColor'}>
                    {val.produit?.description}
                </Text> */}

                                                <Flex justifyContent="space-between" w='full'>
                                                    {val.color && <Flex gap={2}>
                                                        <Text color='gray'>{t('Couleur')} :</Text>
                                                        <Text fontWeight='semibold'>{val.color}</Text>
                                                    </Flex>}
                                                    {val.size && <Flex gap={2}>
                                                        <Text color='gray'>{t('Taille')} :</Text>
                                                        <Flex gap={1}>
                                                            <Text fontWeight='semibold'>{val.size}</Text>
                                                        </Flex>
                                                    </Flex>}
                                                </Flex>

                                                <Flex justifyContent="space-between" w='full'>
                                                    <Flex gap={2}>
                                                        <Text color='gray'>{t('Qté')} :</Text>
                                                        <Text fontWeight='semibold'>{val.quantity}</Text>
                                                    </Flex>
                                                    <Flex gap={2}>
                                                        <Text color='gray'>{t('Prix')} :</Text>
                                                        <Flex gap={1}>
                                                            <Text fontWeight='semibold'>{val.price}</Text>
                                                            <Text fontWeight='gray' fontSize={13}></Text>
                                                        </Flex>
                                                    </Flex>
                                                </Flex>

                                            </Stack>
                                        </CardBody>
                                    </Card>
                                )
                            })}

                    </SimpleGrid>

                </ModalContent>
            </Modal >

        </Box >
    )
}

export default Stock